import React from "react";
import PropTypes from "prop-types";
import { Box, TextField } from "@mui/material";

import { DWB_LABEL_MAP } from "../../hooks/bondsEndorsementSharedConfig";

export default function EndorsementDwbNameFields({
  selectedBondToEndorse,
  updatedName,
  setUpdatedName,
  dwbFirstName,
  setDwbFirstName,
  dwbMiddleName,
  setDwbMiddleName,
  dwbLastName,
  setDwbLastName,
  dwbSuffix,
  setDwbSuffix,
  dwbAlias,
  setDwbAlias,
}) {
  const labels = DWB_LABEL_MAP[selectedBondToEndorse?.bond_type] || DWB_LABEL_MAP.Probate;
  if (labels.single) {
    return (
      <TextField
        label={labels.prefix}
        value={updatedName}
        onChange={(e) => setUpdatedName(e.target.value)}
        fullWidth
        required
        sx={{ mb: 3 }}
      />
    );
  }
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 3 }}>
      <Box sx={{ display: "flex", gap: 2 }}>
        <TextField
          label={`${labels.prefix} First Name`}
          value={dwbFirstName}
          onChange={(e) => setDwbFirstName(e.target.value)}
          fullWidth
          required
        />
        <TextField
          label={`${labels.prefix} Middle Name`}
          value={dwbMiddleName}
          onChange={(e) => setDwbMiddleName(e.target.value)}
          fullWidth
        />
      </Box>
      <Box sx={{ display: "flex", gap: 2 }}>
        <TextField
          label={`${labels.prefix} Last Name`}
          value={dwbLastName}
          onChange={(e) => setDwbLastName(e.target.value)}
          fullWidth
          required
        />
        <TextField
          label="Suffix"
          value={dwbSuffix}
          onChange={(e) => setDwbSuffix(e.target.value)}
          sx={{ maxWidth: 120 }}
        />
      </Box>
      <TextField
        label={labels.alias}
        value={dwbAlias}
        onChange={(e) => setDwbAlias(e.target.value)}
        fullWidth
      />
    </Box>
  );
}

EndorsementDwbNameFields.propTypes = {
  selectedBondToEndorse: PropTypes.object,
  updatedName: PropTypes.string,
  setUpdatedName: PropTypes.func.isRequired,
  dwbFirstName: PropTypes.string,
  setDwbFirstName: PropTypes.func.isRequired,
  dwbMiddleName: PropTypes.string,
  setDwbMiddleName: PropTypes.func.isRequired,
  dwbLastName: PropTypes.string,
  setDwbLastName: PropTypes.func.isRequired,
  dwbSuffix: PropTypes.string,
  setDwbSuffix: PropTypes.func.isRequired,
  dwbAlias: PropTypes.string,
  setDwbAlias: PropTypes.func.isRequired,
};
